import React from 'react';
import PropTypes from 'prop-types';
import Icon, { GLYPHS } from '../../../common/icon';

const BackButton = ({ onClick, ...props }) => (
  <button type="button" onClick={onClick} className="c-btn c-btn--blank" {...props}>
    <Icon glyph={GLYPHS.back} />
  </button>
);
BackButton.propTypes = {
  onClick: PropTypes.func.isRequired,
};

export default BackButton;
